var React = require('react');

function LinkLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.84 47.99a9 9 0 01-6.34-2.62l-1.88-1.88a9 9 0 010-12.69l12.21-12.21a9 9 0 0112.69 0l1.88 1.88a1 1 0 11-1.42 1.41L26.12 20a7 7 0 00-9.86 0L4.03 32.22a7 7 0 000 9.85l1.88 1.88a7 7 0 009.86 0l8.46-8.45a1 1 0 011.41 1.41l-8.45 8.46a9 9 0 01-6.35 2.62z","key":0}),React.createElement("path",{"d":"M26.81 32.03a8.93 8.93 0 01-6.34-2.66l-1.88-1.88a.999.999 0 010-1.42 1 1 0 011.41 0l1.88 1.88a6.93 6.93 0 004.93 2 7 7 0 004.93-2l12.21-12.18a7 7 0 000-9.86l-1.83-1.87a7 7 0 00-9.85 0l-8.51 8.45a1 1 0 11-1.41-1.42l8.45-8.45a9 9 0 0112.69 0l1.87 1.86a9 9 0 010 12.68L33.12 29.37A9 9 0 0126.78 32l.03.03z","key":1})]);
}

LinkLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = LinkLight;

LinkLight.default = LinkLight;
